import * as actionTypes from './actionTypes';

export interface SetEmbeddedWindowAction{
    type: "SET_EMBEDDED";
    payload: {
        value: boolean;
        stateLocation: string;
    };
}
export function setEmbedded(IsEmbedded: boolean, stateLocation: string): SetEmbeddedWindowAction
{
    return {
        type: actionTypes.SET_EMBEDDED,
        payload: {
            value: IsEmbedded,
            stateLocation: stateLocation,
        },
    };
}


// WEBPACK FOOTER //
// ./modules/embedded-iva/actions/actions.ts